import * as yup from 'yup';

export const yupValidatePassword = (label = 'password') => {
  return yup
    .string()
    .label(label)
    .min(8, `The minimum ${label} length is 8!`)
    .matches(/[a-z]/, `The ${label} must contain one lowercase character!`)
    .matches(/[A-Z]/, `The ${label} must contain one uppercase character!`)
    .matches(
      /[^A-Za-z0-9]/,
      `The ${label} must contain one special character!`,
    );
};
